import { useQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { FetchCampaignMetrics } from '../api/fetch-campaign-metrics';

export function useCampaignMetrics(campaignId: string) {
  const queryKeys = useQueryKeys();

  return useQuery({
    queryKey: queryKeys.campaign.metrics(campaignId),
    queryFn: async ({ signal }) => FetchCampaignMetrics(campaignId, signal),
  });
}
